import request from "@/utils/request";

export default function agentGetGroupDetailById(params) {
    return request({
        url: `/device/deviceGroup/agentGetGroupDetailById`,
        params
    })
}
